// Module
var code = "<div data-bind=\"if: loggedIn\"> <default-page-logged-in-component></default-page-logged-in-component> </div> <div data-bind=\"ifnot: loggedIn\"> <default-page-logged-out-component></default-page-logged-out-component> </div>";
// Exports
export default code;